import * as $ from "jquery";

export default class BoostsComponent {
    constructor() {
        this.componentSelector = "#boostplans";
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;

        instance.filter('active', instance);
        $('#boostplan-list').show();

        $('#boostplans .tab-pane').off().on('click', function () {
            $('#boostplans .tab-pane').removeClass("active");
            $(this).addClass("active");

            let filterKey = $(this).attr('data-filter');
            instance.filter(filterKey, instance);
        });
    }

    filter(filterKey, instance) {
        if (filterKey !== 'all') {
            $('.boostplan-card').hide();
            $('.boostplan-card[data-state="' + filterKey + '"]').show();
        }
        else
            $('.boostplan-card').show();
    }
}